import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import * as MuiIcons from "@mui/icons-material";
import {Box, Button, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import TableHeader from "../../layout/table/TableHeader.js";
import NoDataLabel from "../../layout/NoDataLabel.js";
import ModalDelete from "../../layout/ModalDelete.js";
import Constants from "../../../../utils/constants.js";
import {getPicto} from "../../../../utils/pictoCatalog.js";

const NATURE_LABEL = {LAVAGE: "Lavage", BOOLEEN: "Booléen", CHECKLIST: "Checklist"};

const headCells = [
    {id: "picto", label: "Icône"},
    {id: "code", label: "Code"},
    {id: "libelleFr", label: "Libellé"},
    {id: "nature", label: "Nature"},
    {id: "elements", label: "Zones"},
];

function Picto({pictoKey}) {
    const entry = getPicto(pictoKey);
    const Cmp = MuiIcons[entry.mui] || MuiIcons.Help;
    return <Cmp/>;
}

export default function ActeTable({actes = [], onDelete}) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(null);

    const handleEditClick = (id) => navigate(Constants.APP_ROUTE_ADMIN_ACTES_EDIT.replace(":id", id));

    const openDeleteConfirmModal = (a) => {
        setCurrent(a);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setCurrent(null);
    };
    const handleDelete = () => {
        onDelete(current);
        handleClose();
    };

    return (
        <>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="actes table" size="small">
                    <TableHeader headCells={headCells}/>
                    <TableBody>
                        {actes.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={6} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucun acte enregistré"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {actes.map((a) => (
                            <TableRow key={a.id} hover style={{cursor: "pointer"}} onClick={() => handleEditClick(a.id)}>
                                <TableCell><Picto pictoKey={a.picto}/></TableCell>
                                <TableCell>{a.code}</TableCell>
                                <TableCell>{a.libelleFr}</TableCell>
                                <TableCell><Chip size="small" label={NATURE_LABEL[a.nature] || a.nature}/></TableCell>
                                <TableCell>{a.nature === "CHECKLIST" ? (a.elements ? a.elements.length : 0) : "—"}</TableCell>
                                <TableCell>
                                    <Stack direction={"row"} spacing={2} justifyContent={"end"}>
                                        <Button color="secondary" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick(a.id);
                                                }}
                                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                            Éditer
                                        </Button>
                                        <Button color="error" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDeleteConfirmModal(a);
                                                }}
                                                startIcon={<CloseOutlinedIcon/>}>
                                            Supprimer
                                        </Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ModalDelete
                label={"Êtes-vous sûr de vouloir supprimer l'acte : "}
                onClose={handleClose}
                open={open}
                objectToDelete={current?.libelleFr}
                selectedValue={current}
                onDelete={handleDelete}
            />
        </>
    );
}
